import React, { useEffect, useState } from 'react';
import { OrganizationAccessRightDto, OrganizationInfoDto, RepositoryAccessRightDto, RepositoryDto } from '../models/APIModels';
import { Box, Chip, Grid, IconButton } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import CancelIcon from '@mui/icons-material/Cancel';
import AutoCompleteAsync from './AutoComplete/AutoCompleteAsync';
import { ApiHelper } from '../common/ApiHelper';
import AutoComplete from './AutoComplete/AutoCompleteSelect';
import { USER_ROLE } from '../constants';
import useAppUtils from '../Utils/useAppUtils';

interface Iprops {
  updateAccessInfo?: any;
  isEditingDisable: boolean;
  repositoryItem?: RepositoryDto | null;
  orgainizationItem?: OrganizationInfoDto | null;
  users?:RepositoryAccessRightDto[] | OrganizationAccessRightDto[];
  title: string;
  entity:string;
}

const UserManagement = ({ title, updateAccessInfo, repositoryItem, isEditingDisable, orgainizationItem, users, entity }: Iprops) => {
  // const [users, setUsers] = useState<RepositoryAccessRightDto[] | OrganizationAccessRightDto[]>([]);
  const [userAccess, setUserAccess] = useState('');
  const [enableAddUser, setEnableAddUser] = useState(true);
  const [selectedUserArr, setSelectedUserArr] = useState<string[]>([]);
  const { alert , confirm} = useAppUtils();
  const [editMode, setEditMode] = useState(false);
  const [selectedUser, setSelectedUser] = useState();


  const handleDeleteUser = (e, user) => {
    const newRepositoryArr: any = users.filter((item) => item.userId !== user.userId);
    if (newRepositoryArr.length > 0 && newRepositoryArr.filter((item) => item.roles.includes('Admin') || item.roles.includes('SuperAdmin') ).length > 0) {
      // setNewRepArr(newRepositoryArr);
      updateAccessInfo(newRepositoryArr);
    } else {
      alert(`${entity} should have at least one admin.`, 'error');
    }
  };
  const handleEditUser = (e, user) => {
    if (user) {
      const roleName = user.roles[0];
      const role = USER_ROLE.find((r) => r.name === roleName);
      setEditMode(true);
      setSelectedUserArr([user]);
      setSelectedUser(user);
      if (role) {
        setUserAccess(role)
      }
    }
  };

  const addNewUser = () => {
    setEnableAddUser(true);
    setEditMode(false);
    setSelectedUserArr([]);
    setSelectedUser(null);
    setUserAccess('')
  }

  const handleAddUser = (userRole) => {

    if (userRole && selectedUserArr.length === 0) {
      alert('Please select an User', 'error');
      return;
    }
    else if (selectedUserArr.length > 0 && userRole) {
      const existingUserArr = users;
      selectedUserArr.map((user) => {
        const index = existingUserArr?.findIndex((e) => e.userId === user.userId);
        // console.log('index', index);
        if (index === -1) {
          existingUserArr.push({
            ...user,
            roles: [userRole.name],
          });
          setUserAccess(userRole);
        } else {
          if (editMode) {
            existingUserArr[index] = {
              ...user,
              roles: [userRole.name],
            }
          } else {
            alert('User Already Exists.', 'error');
            return;
          }
        }
        // console.log('existingUserArr', existingUserArr)
      });
      updateAccessInfo(existingUserArr);
      clearUserForm();
      
      // setEnableAddUser(false);
    } else {
      alert('No user found.', 'error');
    }
  };
  const clearUserForm = () => {
    if (!editMode) {
      setSelectedUserArr([]);
      setUserAccess('');
    }
  }
  const handleSearchUser = async (inputValue) => {
    if (inputValue === '') {
      return [];
    }
    try {
      const resp = await ApiHelper.SearchUser(inputValue);
      if (resp.data) {
        let autoSelectArr = resp.data.map((item) => {
          return {
            userId: item.userId,
            userDisplayName: item.displayName,
          };
        });
        return autoSelectArr;
      } else {
        return [];
      }
    } catch (e) {}
  };
  useEffect(() => {
    if (repositoryItem && !orgainizationItem) {
      // setUsers(repositoryItem.repositoryAccessRights);
    }
  }, [repositoryItem]);
  useEffect(() => {
    if (!repositoryItem && orgainizationItem) {
      // setUsers(orgainizationItem.users);
    }
  }, [orgainizationItem]);

  useEffect(() => {
    // console.log('users changed', users);
  }, [users])
  useEffect(() => {
    // console.log('userAccess changed', userAccess);
  }, [userAccess])
  useEffect(() => {
    // console.log('selectedUserArr changed', selectedUserArr);
    if (selectedUserArr.length === 0) {
      setUserAccess('');
    } 
  }, [selectedUserArr])

  return (
    <div className="user-management-container">
      <Grid container spacing={2} >
        <Grid item xs={12}>
          <Box className="hedading" >
            <p className="title" style={{ fontSize: '18px' }}>
              {title}
            </p>
            <div className="line"></div>
          </Box>
        </Grid>
        {users &&
          users.length > 0 &&
          users.map((user, index) => {
            return (
              <Grid item xs={6} sm={4} md={4} key={users.indexOf(user)}>
                <Chip
                  label={user.userDisplayName}
                  variant={selectedUser && selectedUser.userId === user.userId ? 'filled' : 'outlined'}
                  color="success"
                  size="small"
                  // avatar={<Avatar color="success">{input.name.charAt(0)}</Avatar>}
                  onDelete={(e) => handleDeleteUser(e, user)}
                  onClick={(e) => handleEditUser(e, user)}
                  clickable
                  title={user.userDisplayName}
                  sx={{cursor: isEditingDisable ? 'not-allowed' : 'pointer'}}
                  deleteIcon={
                    <IconButton disabled={isEditingDisable}>
                      <CancelIcon fontSize="small" />
                    </IconButton>
                  }
                />
              </Grid>
            );
          })}
        <Grid item xs={6} sm={6} md={6}>
        <Chip
            label="Add New User"
            // variant="outlined"
            color="primary"
            size="small"
            clickable
            disabled={isEditingDisable}
            icon={<AddIcon />}
            // onClick={(e) => addNewInput()}
            onClick={addNewUser}
          />
        </Grid>
        {enableAddUser && (
          <>
            <Grid item xs={12}>
              <Box className="hedading" >
                <p className="title" style={{ fontSize: '18px' }}>
                  Access Configuration
                </p>
                <div className="line"></div>
              </Box>
            </Grid>
            <Grid item xs={12}>
            <AutoCompleteAsync
              getAsyncData={handleSearchUser}
              InputSize="small"
              styleProps={{ marginBottom: '0px' }}
              label="Search User"
              existingUserArr={users}
              onSelection={setSelectedUserArr}
              selectedValues={selectedUserArr}
            />
            </Grid>
            <Grid item xs={12}>
            <AutoComplete
                id="select-role"
                items={USER_ROLE}
                itemText="label"
                itemKey="id"
                labelText="Role"
                placeHolderText="Select option"
                multiSelect={false}
                onChange={handleAddUser}
                defaultValue={userAccess ?? ''}
                disabled={selectedUserArr.length === 0}
              />
            </Grid>
          </>
        )}
      </Grid>
    </div>
  );
};

export default UserManagement;
